import React from "react"
import { Typography, Box, useTheme } from "@mui/material"
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined"
import ClosedCaptionOutlinedIcon from "@mui/icons-material/ClosedCaptionOutlined"

export const TheatreShowtime = ({ theatre, language, caption, showtime }) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`MovieTheatre`]?.styleOverrides || {}
  const {
    root,
    theatreContainer,
    titleTypography,
    bodyTypography,
    showTimeContainer,
    showTimeTypography,
    timeSlotsContainer,
    movieDetailsWrapper,
    contentWrapper,
  } = styleOverrides

  return (
    <Box sx={root}>
      <Box sx={theatreContainer}>
        <Typography sx={titleTypography}> {theatre} </Typography>
        <Box sx={movieDetailsWrapper}>
          <Box sx={contentWrapper}>
            <VolumeUpOutlinedIcon />
            <Typography variant="subtitle1">{language}</Typography>
          </Box>
          <Box sx={contentWrapper}>
            <ClosedCaptionOutlinedIcon />
            <Typography variant="subtitle1">{caption}</Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <Box sx={showTimeContainer}>
          <Typography sx={bodyTypography} variant="body1">
            SHOWTIME:
          </Typography>
          <Box sx={timeSlotsContainer}>
            {showtime.map((time, index) => (
              <Typography
                key={index}
                variant="body1"
                className={index === 0 ? "is-active" : ""}
                // TODO:: implement logic for finding the approaching showtime at the theater
                sx={showTimeTypography}
              >
                {time}
              </Typography>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
